import React from 'react'
import { useAppMeta } from "hooks";
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify";
import { useGetVehicleMaintenanceDetailQuery, useUpdateVehicleMaintenanceMutation } from "store/services/vehicleMaintenanceApi";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import VehicleMaintenanceForm from "./VehicleMaintenanceComponents/VehicleMaintenanceForm";

const VehicleMaintenanceEditScreen = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Vehicle Maintenance", path: "/app/crm/vehicle-maintenance/list" },
    { title: "Edit VehicleMaintenance" },
  ];

  // RTK Query
  const {
    data: vehicleMaintenanceDetails,
    isLoading: loadingMaintenance,
    error,
  } = useGetVehicleMaintenanceDetailQuery(id)

  const [updateMaintenance, { isLoading: updatingMaintenance }
  ] = useUpdateVehicleMaintenanceMutation();

  // methods
  const handleUpdateVehicleMaintenance = async (data) => {
    const _payload = data;

    delete _payload.disclaimers;
    try {
      await updateMaintenance({ ..._payload },).unwrap();
      toast.success("VehicleMaintenance successfully updated!");
      navigate(`/app/crm/vehicle-maintenance/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update VehicleMaintenance!"
      );
    }
  };

  useAppMeta("Edit VehicleMaintenance");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingMaintenance || updatingMaintenance}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <VehicleMaintenanceForm
          isBusy={loadingMaintenance || updatingMaintenance}
          vehicleMaintenanceDetail={vehicleMaintenanceDetails}
          onSubmit={handleUpdateVehicleMaintenance}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default VehicleMaintenanceEditScreen;